import {Button, NumberInput, Paper, Select} from "@mantine/core";
import { Plus as IconPlus } from "@phosphor-icons/react";
import {useCallback, useContext, useEffect, useMemo, useState} from 'react';
import {Row, Col} from "../../../components/Flex/Flex";
import MessageContext from "../../../context/MessageContext";
import {negativeInputMode} from "../../../utils/Utils.ts";
import {distances} from "../data.js";
import api, {useSWCLocation} from "../../../utils/api.ts";
import DirectionInput from "./DirectionInput.jsx";

const optDistance = distances.map(d => ({value: d, label: d}));

const initFromLocation = location => {
    if(location) {
        return {
            id: location.system.attributes.uid,
            x: location.coordinates.galaxy.attributes.x,
            y: location.coordinates.galaxy.attributes.y,
        }
    } else {
        return {id: '', x: null, y: null};
    }
}
export default function AddScan({contractId, systems, onSave}) {
    const {location} = useSWCLocation();
    const {error} = useContext(MessageContext);
    const [system, setSystem] = useState({id: '', x: null, y: null});
    const [direction, setDirection] = useState('');
    const [distance, setDistance] = useState('Unknown');

    const systemOptions = useMemo(() => systems.map(s => ({value: s.id, label: s.name})), [systems]);

    const onSystemSelect = useCallback((val) => {
        let s = systems.find(s => s.id === val);
        if(s && s.galX && s.galY) {
            setSystem({id: val, x: s.galX, y: s.galY});
        } else {
            error('Invalid system selection', `An error occurred while selecting system with ID '${val}'.`)
        }
    }, [systems]);

    const onCoordChange = useCallback((type, val) => {
        setSystem(prev => {
            let x = type==='x' ? val : prev.x;
            let y = type==='y' ? val : prev.y;

            let s = systems.find(s => s.galX == x && s.galY == y);
            if(s) {
                return {id: s.id, x, y};
            } else {
                return {id: '', x, y};
            }
        })
    }, [systems]);

    const canAddScan = system.x !== null && system.y !== null
        && distance !== null && distance !== ''
        && (direction !== '' || distance === 'Lock');

    const addScan = () => {
        if(system.x === null || system.y === null) {
            error('Select where you scanned from');
            return;
        }
        if(distance === null || distance === '') {
            error('Select the distance');
            return;
        }
        if(direction === '' && distance !== 'Lock') {
            error('Select the direction');
            return;
        }
        if(distance === 'Lock' && system.id === '') {
            error('Missing System', 'You cannot lock on a deep space location');
            return;
        }
        api.post('/bh/scan/'+contractId, {system: system.id, x: system.x, y: system.y, distance, direction}).then(res => {
            onSave(res.data.contract);
            setSystem(initFromLocation(location));
            setDirection('');
            setDistance('Unknown');
        }).catch(err => {
            if(err.response?.data?.message) {
                error('Could not add scan', err.response.data.message);
            } else {
                error('Could not add scan');
            }
            console.error(err);
        });
    }

    useEffect(() => {
        setSystem(initFromLocation(location));
    }, [location]);


    return (
        <Paper>
            <h3 className="mt-0">Add new scan</h3>
            <Row align="center">
                <Col grow={1}>
                    <Select id="system" data={systemOptions} value={system.id || null} onChange={onSystemSelect} searchable placeholder="System" />
                </Col>
                <Col grow={1}>
                    <Row mb={0}>
                        <Col><NumberInput size="xs" value={system.x ?? ''} min={-500} max={500} onChange={(val) => onCoordChange('x', val)} placeholder="X" inputMode={negativeInputMode} /></Col>
                        <Col><NumberInput size="xs" value={system.y ?? ''} min={-500} max={500} onChange={(val) => onCoordChange('y', val)} placeholder="Y" inputMode={negativeInputMode} /></Col>
                    </Row>
                </Col>
                <Col grow={1}>
                    <Select id="distance" data={optDistance} value={distance} onChange={val => setDistance(val)} placeholder="Distance" />
                </Col>
                <Col grow={1}>
                    <DirectionInput value={direction} onChange={dir => {
                        console.log('CLICKED', dir)
                        setDirection(dir)}} disabled={distance === 'Lock'} />
                </Col>
                <Col>
                    <Button onClick={addScan} leftSection={<IconPlus size={16}/>} disabled={!canAddScan}>Add</Button>
                </Col>
            </Row>
        </Paper>


    )
}
